// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
import * as listOverrides from '../Extensions/Core/ListOverrides'

import {ProgramEnvironmentalBenefitProjection} from './ProgramEnvironmentalBenefitProjection';
import {Milestone} from './Milestone';

const _associations = [
			{
				name: 'ProgramEnvironmentalBenefitProjections',
				model: new ProgramEnvironmentalBenefitProjection(),
				type: 'ArrayOfChildren',
				using: 'programEnvironmentalBenefitId',
				isHidden: true,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: false,
				isMutable: true,
				requiresPermission: null,
				group: 'Projections',
				groupTitle: 'Projections',
				displayOrder: 3,
				itemTitle: 'Projection',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: listOverrides.InnerStreamBankMutableList,
				customData: {
				}
			},
			{
				name: 'Milestones',
				model: new Milestone(),
				type: 'ArrayOfChildren',
				using: 'programEnvironmentalBenefitId',
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: false,
				isMutable: true,
				requiresPermission: null,
				group: 'Milestones',
				groupTitle: 'Milestones',
				displayOrder: 4,
				itemTitle: 'Milestone',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: listOverrides.InnerStreamBankMutableList,
				customData: {
				}
			},
];

const _fieldDefs = [
			{
				title: 'programEnvironmentalBenefitId',
				placeholder: null,
				key: 'programEnvironmentalBenefitId',
				isPrimaryKey: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.programEnvironmentalBenefitId,
				setter: (x, y) => x.programEnvironmentalBenefitId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'programId',
				placeholder: null,
				key: 'programId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.programId,
				setter: (x, y) => x.programId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Benefit Type',
				placeholder: null,
				key: 'environmentalBenefitId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 1,
				getter: (x) => x.environmentalBenefitId,
				setter: (x, y) => x.environmentalBenefitId = y,
				defaultValue: null,
				editor: 'ProgramEnvironmentalBenefitFieldEditor',
				viewer: 'EnvironmentalBenefitFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Program Target Value',
				placeholder: null,
				key: 'targetValue',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 2,
				getter: (x) => x.targetValue,
				setter: (x, y) => x.targetValue = y,
				defaultValue: null,
				editor: 'ProgramEnvironmentalBenefitsTargetValueEditor',
				viewer: 'ProgramEnvironmentalBenefitsTargetValueViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'created',
				placeholder: null,
				key: 'created',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.created,
				setter: (x, y) => x.created = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'modified',
				placeholder: null,
				key: 'modified',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.modified,
				setter: (x, y) => x.modified = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deleted',
				placeholder: null,
				key: 'deleted',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deleted,
				setter: (x, y) => x.deleted = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Upload Projection File',
				placeholder: null,
				key: 'fileUploadId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 5,
				getter: (x) => x.fileUploadId,
				setter: (x, y) => x.fileUploadId = y,
				defaultValue: null,
				editor: 'ProgramBenefitFileUploadFieldEditor',
				viewer: 'FileUploadFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
					contextNodeIdFetch: (x) => [x.contextNodeId],
				}
			},
			{
				title: 'deletedKey',
				placeholder: null,
				key: 'deletedKey',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deletedKey,
				setter: (x, y) => x.deletedKey = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class ProgramEnvironmentalBenefit extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
